import { render, staticRenderFns } from "./social-account.vue?vue&type=template&id=8186e590&"
import script from "./social-account.vue?vue&type=script&lang=js&"
export * from "./social-account.vue?vue&type=script&lang=js&"
import style0 from "./social-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports